<template>
  <div class="rate" :class="{'disabled':disabled}">
    <div class="star-wrap">
      <i
        v-for="(i, index) in 5"
        :key="index"
        @click="disabled ? '' : setScore(i)"
        :class="getClass(i)"
      >
        <i v-if="disabled&&i==Math.floor(score)+1" class="icon-star" :style="'width:'+width"></i>
      </i>
    </div>
    <span v-if="showText" class="desc-text">{{desc[score - 1]}}</span>
  </div>
</template>
<script>
export default {
  name: 'MyRate',
  props: {
    score: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      curScore: '',
      width: '',
      desc: [ this.$t('feedback.vbad'), this.$t('feedback.notgood'), this.$t('feedback.justsoso'), this.$t('feedback.Nice'), this.$t('feedback.Excellent')],
    }
  },
  created: function () {
    this.getDecimal()
  },
  methods: {
    getClass (i) {
      if (this.curScore === '') {
        return i <= this.score ? 'icon-star' : 'icon-star-o'
      } else {
        return i <= this.curScore ? 'icon-star' : 'icon-star-o'
      }
    },
    getDecimal () {
      this.width = Number(this.score * 100 - Math.floor(this.score) * 100) + '%'
    },
    setScore (i) {
      this.$emit('update:score', i)
    }
  }
}
</script>
<style lang="less" scoped>
.rate{
  display: flex;
  align-items: center;
  .desc-text{
    font-size: 14px;
    color: #8C8C8C;
    margin-left: 12px;
  }
  .star-wrap{
    display: inline-block;
    line-height: 0;
    .icon-star-o{
      position: relative;
      width: 33px;
      height: 32px;
      line-height: 0;
      display: inline-block;
      margin-right: 2px;
      background: url('https://cdn.ecarxgroup.com/f-static/feedback-star-dark.png') 0 0 ~'/' auto 100%;
      .icon-star{
        position: absolute;
        left:0;
        top:0;
      }
    }
    .icon-star{
      width: 33px;
      height: 32px;
      line-height: 0;
      display: inline-block;
      margin-right: 2px;
      background: url('https://cdn.ecarxgroup.com/f-static/feedback-star-light.png') 0 0 ~'/' auto 100%;
    }
    i:last-child{
      margin-right: 0px;
    }
  }
}
</style>